<template>
	<fulfill-comment v-if="fi.type === 'fulfill-comment'" :fi="fi"></fulfill-comment>
	<fulfill-feedback v-else-if="fi.type === 'fulfill-feedback'" :fi="fi"></fulfill-feedback>
	<info-feedback v-else-if="fi.type === 'info-feedback'" :fi="fi" :responsible="responsible"></info-feedback>
	<see-this v-else-if="fi.type === 'see-this'" :fi="fi" :responsible="responsible"></see-this>
	<info-completed v-else-if="fi.type === 'info-completed'" :fi="fi" :responsible="responsible" :entered-by="enteredBy"></info-completed>
	<micro-task v-else-if="fi.type === 'micro-task'" :fi="fi" :responsible="responsible" :entered-by="enteredBy" :reload="!!reload"></micro-task>
</template>

<script setup lang="ts">
import {ref, computed, onBeforeMount} from "vue";
import type {ForceInfo} from "@t/processes/ForceInfo.ts";
import FulfillComment from "@/processes/FulfillComment.vue";
import FulfillFeedback from "@/processes/FulfillFeedback.vue";
import InfoFeedback from "@/processes/InfoFeedback.vue";
import {useUserStore} from "@/store/UserStore.ts";
import SeeThis from "@/processes/SeeThis.vue";
import InfoCompleted from "@/processes/InfoCompleted.vue";
import MicroTask from "@/processes/MicroTask.vue";

const props = defineProps<{
	fi:ForceInfo
	/** Reload current page on force info completion (use on JSP pages) */
	reload?: boolean
}>();
const us = useUserStore();
const responsible = ref<string>("");
const enteredBy = ref<string>("");

onBeforeMount(() => {
	us.findName(props.fi.responsible).then((n) => responsible.value = n);
	us.findName(props.fi.enteredBy).then((n) => enteredBy.value = n);
});
</script>

<style>

</style>